export default __webpack_public_path__ + "static/media/php.a0d6ffbb.svg";